// @flow

import React, { Fragment } from "react";
import classNames from "classnames";
import { localize } from "redux-i18n";

export type ColConfig<T> = $Exact<{
  name: string,
  title?: string | React$Node,
  renderItem?: (line: T) => ?string | React$Node,
  align?: "left" | "center" | "right",
  width?: number,
  columnClassName?: string,
  getCellClassName?: (row: T) => ?string,
}>;

type SimpleGridProps<T> = {
  className?: string,
  rows: Array<T>,
  columns: Array<ColConfig<T>>,
  noResultsText: string,
  ...PropsFromLocalize,
};

export class SimpleGrid<T: Object> extends React.Component<SimpleGridProps<T>> {
  get noResultsText() {
    return this.props.noResultsText || this.props.t("NO_RESULTS_TEXT");
  }

  render() {
    if (this.props.rows && this.props.rows.length < 1) {
      return <div className="text-left text-secondary fs-28">{this.noResultsText}</div>;
    }

    return (
      <table className={classNames("simple-grid", this.props.className || "theme-help")}>
        <thead>
          <tr>
            {this.props.columns.map(col => {
              if (col.title) {
                return (
                  <th
                    key={col.name}
                    style={{
                      width: col.width ? `${col.width}px` : null,
                    }}
                  >
                    <div
                      className={classNames("d-flex", {
                        "justify-content-start": !col.align || col.align === "left",
                        "justify-content-center": col.align === "center",
                        "justify-content-end": col.align === "right",
                      })}
                    >
                      {col.title || ""}
                    </div>
                  </th>
                );
              }
            })}
          </tr>
        </thead>
        <tbody>
          {this.props.rows &&
            this.props.rows.map((row, i) => (
              <tr key={row.id || i}>
                {this.props.columns.map(col => (
                  <td
                    key={col.name}
                    style={{
                      width: col.width ? `${col.width}px` : null,
                    }}
                    className={classNames(
                      col.columnClassName,
                      col.getCellClassName && col.getCellClassName(row),
                    )}
                  >
                    <div
                      className={classNames("d-flex", {
                        "justify-content-start": !col.align || col.align === "left",
                        "justify-content-center": col.align === "center",
                        "justify-content-end": col.align === "right",
                      })}
                    >
                      {col.renderItem ? col.renderItem(row) : row[col.name]}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    );
  }
}

export default localize()(SimpleGrid);
